import { Table } from "semantic-ui-react";

import React from "react";

import getArticleChannelData from "astrid-firestore/src/api/articles/getArticleChannelData";

export default function ArticleChannelDataCell({ article, channel, attribute, label, renderValue }) {
	const enabled = article.channelIds?.includes(channel.id);
	const value = getArticleChannelData(article, channel.id, attribute);

	if (!enabled || !value) {
		return <Table.Cell collapsing />;
	}

	return (
		<Table.Cell collapsing>
			<p style={{ opacity: 0.4, fontWeight: 300, fontSize: "0.9em" }}>{label}</p>

			{renderValue ? renderValue(value) : value}
		</Table.Cell>
	);
}
